import { isEmpty } from 'core/utils/general-utils'
import { DVBCRowType, FrequencyLimitsType } from '../dvbc/redux/types'
import { RfTuningStatusResult } from '../status/redux/types'
import { getIsBERHealthy, getIsPWRHealthy } from './thresholds'
import { FrequencyRow } from './types'

export function getModule(frequency: string, frequencyLimits: FrequencyLimitsType) {
  if (!isEmpty(frequencyLimits)) {
    const limitFrquencyToCompare = frequencyLimits.find(
      (e) => e.lf === frequency
    )
    return limitFrquencyToCompare ? limitFrquencyToCompare.modulation : '-'
  }
}

export function DVBCHistoryMapping(dvbc: Array<DVBCRowType>, frequencyLimits: FrequencyLimitsType): Array<FrequencyRow> {
  return dvbc.map(frequency => ({
    LF: frequency.LF,
    LS: frequency.LS.toString(),
    TSID: frequency.TSID,
    modulation: getModule(frequency.LF, frequencyLimits),
    PWR: {
      value: parseFloat(frequency.PWR),
      isHealthy: getIsPWRHealthy(frequency.LF, parseFloat(frequency.PWR), frequencyLimits),
    },
    BERPO: {
      value: frequency.BERPO,
      isHealthy: getIsBERHealthy(frequency.LF, frequency.BERPO, frequencyLimits),
    },
  }))
}

export function frequencyScanMapping(frequencies: Array<RfTuningStatusResult>, frequencyLimits: FrequencyLimitsType): Array<FrequencyRow> {
  return frequencies.map(frequency => ({
    LF: frequency.LF,
    LS: frequency.LS,
    TSID: frequency.TSID,
    modulation: getModule(frequency.LF, frequencyLimits),
    PWR: {
      value: parseFloat(frequency.PWR),
      isHealthy: getIsPWRHealthy(frequency.LF, parseFloat(frequency.PWR), frequencyLimits),
    },
    BERPO: {
      value: frequency.BERPO,
      isHealthy: getIsBERHealthy(frequency.LF, frequency.BERPO, frequencyLimits),
    },
  }))
}